import React, { Component } from 'react'
import { Container, Header, Image, Accordion, Icon } from 'semantic-ui-react'
import Fade from 'react-reveal/Fade'
import '../styles/sessionsSection.scss';

export default class SessionsSection extends Component {

    state = { activeIndex: 0 }

  handleClick = (e, titleProps) => {
    const { index } = titleProps
    const { activeIndex } = this.state
    const newIndex = activeIndex === index ? -1 : index

    this.setState({ activeIndex: newIndex })
  }


    render() {

         const { activeIndex } = this.state

        return <div id="sessions" className="content-deck sessions">
            <h1 className="content-deck__headline"> Sessions </h1>
            <Container>
              <Accordion fluid styled>
                <Accordion.Title active={activeIndex === 0} index={0} onClick={this.handleClick}>
                  <Icon name="dropdown" />
                  Breakout Session 1 
                  <span className="date-time"> Nov 16th 9:00 - 10:00 AM </span>
                </Accordion.Title>
                <Accordion.Content active={activeIndex === 0}>
                  <div className="breakouts">
                    <div className="breakout">
                      <h3 className="breakout__title">
                        Do Cats Love you?
                      </h3>
                      <h4 className="breakout__presenter">
                        Dr. McKittens
                      </h4>
                      <p className="breakout__description">
                        Lorem ipsum dolor sit amet, consectetur
                        adipiscing elit. Cras eu mattis erat, non
                        tincidunt quam. Proin eget augue tincidunt,
                        tempus lectus ornare, tincidunt quam. Integer
                        auctor urna magna, id suscipit enim ornare et.
                      </p>
                      <p className="breakout__location">Room A</p>
                    </div>
                    <div className="breakout">
                      <h3 className="breakout__title">
                        Do Cats Love you?
                      </h3>
                      <h4 className="breakout__presenter">
                        Dr. McKittens
                      </h4>

                      <p className="breakout__description">
                        Lorem ipsum dolor sit amet, consectetur
                        adipiscing elit. Cras eu mattis erat, non
                        tincidunt quam. Proin eget augue tincidunt,
                        tempus lectus ornare, tincidunt quam. Integer
                        auctor urna magna, id suscipit enim ornare et.
                      </p>
                      <p className="breakout__location">Room A</p>
                    </div>
                    <div className="breakout">
                      <h3 className="breakout__title">
                        Do Cats Love you?
                      </h3>
                      <h4 className="breakout__presenter">
                        Dr. McKittens
                      </h4>
                      <p className="breakout__description">
                        Lorem ipsum dolor sit amet, consectetur
                        adipiscing elit. Cras eu mattis erat, non
                        tincidunt quam. Proin eget augue tincidunt,
                        tempus lectus ornare, tincidunt quam. Integer
                        auctor urna magna, id suscipit enim ornare et.
                      </p>
                      <p className="breakout__location">Room A</p>
                    </div>
                  </div>
                </Accordion.Content>

                <Accordion.Title active={activeIndex === 1} index={1} onClick={this.handleClick}>
                  <Icon name="dropdown" />
                  Breakout Session 2
                </Accordion.Title>
                <Accordion.Content active={activeIndex === 1}>
                  <p>
                    There are many breeds of dogs. Each breed varies in
                    size and temperament. Owners often select a breed of{' '}
                    dog that they find to be compatible with their own
                    lifestyle and desires from a companion.
                  </p>
                </Accordion.Content>

                <Accordion.Title active={activeIndex === 2} index={2} onClick={this.handleClick}>
                  <Icon name="dropdown" />
                  Breakout Session 3
                </Accordion.Title>
                <Accordion.Content active={activeIndex === 2}>
                  <p>
                    Three common ways for a prospective owner to acquire
                    a dog is from pet shops, private owners, or
                    shelters.
                  </p>
                  <p>
                    A pet shop may be the most convenient way to buy a
                    dog. Buying a dog from a private owner allows you to{' '}
                    assess the pedigree and upbringing of your dog
                    before choosing to take it home. Lastly, finding
                    your dog from a shelter, helps give a good home to a
                    dog who may not find one so readily.
                  </p>
                </Accordion.Content>
              </Accordion>
            </Container>
          </div>
    }
}


// WEBPACK FOOTER //
// ./src/sections/sessionsSection.js